// Complete only missing local fields. Never replace an existing user decision,
// infer demographics, or dispatch a save/Google operation.
export function prepareSearchDraft(draft, recommendation, ads=[]) {
 if(recommendation.targetingAssessment?.status!=='credible')return {draft,repairs:[]};
 const repairs=[];
 const areas=recommendation.qualityAssessment?.areas;
 // Legacy responses retain their existing behavior; assessed responses may only
 // fill fields with positive evidence, independently of evaluation readiness.
 const supported=key=>!areas||areas[key]?.status==='supported';
 const tests=draft.tests.map(group=>{
  if(!group.selected)return group;
  const proposed=recommendation.proposal?.tests?.find(t=>t.id===group.id);
  if(!proposed||JSON.stringify(proposed.targeting)!==JSON.stringify(group.targeting))return group;
  const next={...group};
  const valid=k=>k.keyword?.trim()&&['EXACT','PHRASE','BROAD'].includes(k.match_type);
  if(supported('intentCoverage')&&!group.keywords.length&&proposed.keywords?.length&&proposed.keywords.every(valid)){
   next.keywords=proposed.keywords;
   repairs.push(`${group.name}: proposed ${next.keywords.length} theme-specific keywords from the assistant recommendation.`);
  }else{
   next.keywords=group.keywords.map(k=>{
    if(k.match_type||!supported('intentCoverage'))return k;
    const match=proposed.keywords?.find(p=>p.keyword===k.keyword&&valid(p));
    if(!match)return k;
    repairs.push(`${group.name}: proposed ${match.match_type} matching for “${k.keyword}”.`);
    return {...k,match_type:match.match_type};
   });
  }
  if(!group.ads.length&&supported('adAlignment')&&supported('destinationFit')){
   const suggestions=(recommendation.adSuggestions||[]).filter(s=>s.testId===group.id&&s.reason?.trim()&&ads.some(a=>a.resource===s.resource));
   next.ads=[...new Set(suggestions.map(s=>s.resource))].slice(0,10);
   for(const ref of next.ads){const suggestion=suggestions.find(s=>s.resource===ref);repairs.push(`${group.name}: proposed “${ads.find(a=>a.resource===ref).name}” — ${suggestion.reason}`);}
  }
  return next;
 });
 return {draft:repairs.length?{...draft,tests}:draft,repairs};
}
